/**
 * The marketing palette, in one place.
 *
 * Tailwind reads it for the `zp-*` classes (tailwind.config.js), and the code
 * that has to name a colour as a value — SVG `fill`s and strokes, the Google
 * Maps style, motion keyframes that interpolate between colours — imports it
 * here. A palette change is one edit, rather than one in the config and a
 * hand-copied hex in every drawing that silently falls behind.
 *
 * CommonJS, because tailwind.config.js `require`s it; app code imports it like
 * any other module. The risk ramp is not here — it lives in riskConfig.js so
 * the marketing scale can't drift from the map legend.
 *
 * Contrast for the interaction colour, measured against WCAG AA for body text
 * (4.5:1): #2563EB is 5.17:1 on bg and 4.74:1 on surface, but only 3.47:1 on
 * night — which is why links on the dark sections keep a white hover.
 */
const ZP = {
  bg: "#FFFFFF",
  surface: "#F5F5F5",
  tint: "#ECEEF1",
  paper: "#F2EFE6",
  ink: "#11181C",
  body: "#4C525A",
  slate: "#6E747C",
  night: "#11181C",
  link: "#2563EB",
};

module.exports = { ZP };
